import { Box, Flex, Text } from "@chakra-ui/react";

export default function Unauthorized() {
  return (
    <Flex
      height="100vh" alignItems="center" justifyContent="center" bg="gray.50"  >
      <Box textAlign="center">
        <Text fontWeight="bold" fontSize="5xl" color="red.500">
          401 Unauthorized
        </Text>
        <Text fontSize="2xl" fontWeight="semibold" color="red.400" mt={4}>
         You are not authorised to use this page.
        </Text>
      </Box>
    </Flex>
  );
}
